module.exports = __webpack_public_path__ + "img/scrollTo-hover.a7aad449.svg";